export const originalTextSample = `- ¿Qué os pasa, chavales?
-¡Que susto, joder!

-¡Cristina!

-Eh...  ¿eso es un pei?

-¿Y tú, qué? ¿Me vas a felicitar o qué?

-¿No te he felicitao?

Bueno, pues luego recuérdame y te invito un chupito.

-Awwwwww

-Oye, quien dice chupito...

-Eh... no.

-No se sabe, no se sabe.

-Sujeta, que voy a mear.

-Pos bueno, copa gratis.

-Tío, ¿pero qué es esto?, ¡las cataratas del Niágara!

-A ver, un poquito de silencio, por favor

-Tú, ya pásate el mai

-Vale, vale, vale, espera, espera, espera

-Capital de... Noruega.

-Helsinki
-Oslo
-Helsinki

-¿¡Helsinki!?
-¿Helsinki?

-Toma, toma

-Bueno, a ver da igual

-Lo que te iba a preguntar es que:

¿Cómo sabes que no te gustan las tías,

sin haberte liado con ninguna?

Que es como decir: ¡No, mamá, a mí no me gusta el salmón!

Sin haber probado el salmón

-¡El salmón le gusta a todo el mundo!

-Aparte, que tú tío eres el puto pescador definitivo

Tío, que en 5to de primaria con 11 años se llevaba un rollete

se estaban enrollando en los pasillos

Traumatizaba a todos.

-Escúchame, escúchame:

¿Cómo sabes que no te gustan los tíos, si no has probado un buen rabo?

-¡BUM!

-A ver... que a lo mejor te tengo que poner en tu sitio

¿Cómo sabes tú que no he probado yo un buen rabo?

A lo mejor... a lo mejor lo he probado, y no te lo he dicho

Y me lo he callado

-¡Eso no te lo crees ni tú!

[Cris] -¡Sí, el del Ramón!

¡Eres mentirosa, eh!

Eh... y tú mazo gorrón, ¿no?

-Ha sido él

-Se le ha caído

-Vale

-¿No la quieres?

-Dame

¡Estás a dos manos, cabrón!

-¿Y un chupito, no me invitas?

-No me deja el jefe

-¿En serio?

-Te lo juro

(♪ Reina del sofoque de Shainny ♪)

-Qué soso, ¿no? Bueno, ahora te pago, ¿vale?

¿Qué pasa, Cris?

-¡Eh, has venido!

-Este, que se ha empeñao

Oye, ¿tú te acuerdas de Rubén?

-Eh... sí, pero... hace mazo, ¿no?

-Bueno, tampoco tanto

¿Qué tal?

-Eh.. bien. ¡Dani, ahora vuelvo!

¡Vale!

-Que yo sudo, pero es que me lo encuentro en todos los putos lados

-A ver, ya pero es normal que hoy esté aquí

-Ya, tía, pero es que el otro día en el súper, o sea es que en el súper.

-¿Pero de qué habláis?

-Pues tía, ¿de quién más crees?

-De los tortolitos

-Ya, ¿pero Jorge a estas alturas?

    

-Es que es su ex, ¿qué quieres?

-¿Y?

-Tía, pues es que una cosa es querer ser amigos,

y otra cosa es seguirlo, ¿sabes?

-Bueno, a ver, que dejéis el temita y me déis el dinero, eh

que tengo que pagar.

-Mira, ya te pillarás, ya tú algún día por alguien

y entonces serás tú la que nos dé el coñazo a nosotras

-Mira que lo dudo

-Ya, ya

Tía, yo te lo doy luego, ¿vale? Que me lo he dejado...

¡Va, va, suda!

-Oye, ¿y Alejandro no... no viene?

-Eh, Rubén, dile a mi hermano que le cojo dinero

-Vale

Toma.

Tuyo.
-¡Gracias!

¡Eva!

¿Qué?

Mira.

¡Una polla!

¿Qué es?

-Son de mi hermano, tía. No sé. Pero vamos, que podemos averiguarlo.

-¿Segura?

-Sí, ¿no?

-Oye, pero a la vez, ¿vale?

-Vale

-Eh... si me pasa algo, me cuidas, eh

-Sí, sí, si te da un pajarillo, te sujeto el pelo tía

-Una, dos...

-Vale, una, dos... y tres

Sabe a ibuprofeno, tía.

¿Qué hago con esto?

Trae, trae.

¡Te quiero!
-¡Y yo!

Mmm, ¡temazo!

Las más chungas eh, cuidao.`

